/**
 * The DealOS core-team accounts hidden from the admin conversation list.
 *
 * The addresses are maintained by hand: no Entra group or config source backs
 * this list, so a joiner or leaver has to be reflected here. Matching is exact
 * on the full address, deliberately not on a local-part or domain heuristic,
 * so a real user is never hidden by accident. The filter runs client-side over
 * the page that was fetched, which means the server's pagination total still
 * counts the rows it removes (DOS26-552).
 */
import type { ConversationSummary } from "../types";

/** Core-team usernames, lowercased so lookups can normalise before matching. */
export const CORE_TEAM_USERNAMES: ReadonlySet<string> = new Set([
  "araheja@cvc.com",
  "luke.ferris@cvc.com",
  "stelios.anagnos@cvc.com",
  "jvonroth@cvc.com",
  "cmacgregor@cvc.com",
  "fatima.khan@cvc.com",
  "tuomas.nieminen@cvc.com",
]);

/** Whether a username is one of the core-team accounts, ignoring case and padding. */
export function isCoreTeamUsername(username: string): boolean {
  return CORE_TEAM_USERNAMES.has(username.trim().toLowerCase());
}

/** The rows that are not core-team conversations, in their original order. */
export function withoutCoreTeam(rows: ConversationSummary[]): ConversationSummary[] {
  return rows.filter((row) => !isCoreTeamUsername(row.username));
}
